const configDefault = {
  code: 'default',
  appClassName: 'DEFAULT',
  onlyOneClub: false,
  analytics: {
    // gtm: null,      // GTM container ID (e.g., 'GTM-XXXXXXX')
    // gtag: null,     // GA4 measurement ID (e.g., 'G-XXXXXXX')
    events: {},        // Custom event names to override defaults
    disabledEvents: [] // Event keys to disable for this brand
  },
  favicon: '/favicon.ico',
  title: "Je m'inscris",
  companyName: "Votre Club",
  website: 'https://www.votreclub.com/',
  notifyChannel: 'default-channel',
  header: {
    title: "Je m'abonne",
    logo: "/logo.png",
    urlLogo: null
  },
  footer: {
    logo: "/footer-logo.png",
    textLine: null,
    cgv: {
      link: 'https://www.votreclub.com/cgv/',
      text: 'CGV'
    }
  },
  navigation: {
    display: 'steps', // 'steps' | 'none' | 'line'
    reinitAuto: false,
    reinitAutoSecs: 300,
    allowChangeClub: true,
  },
  promoCode: false,
  payByCard: "PAYLINE",
  // Clé de site Cloudflare Turnstile (publique). Null = pas de vérification anti-robot sur la
  // création de contact. msds-vel-api ne l'exige que pour les VEL de TURNSTILE_ENFORCED_VELS.
  turnstile: {
    siteKey: null,
  },
  choice: {
    selectLabel: 'Sélectionner',
    selectedLabel: 'Sélectionné',
    mandatoryLabel: "Obligatoire",
    nameColor: '#252525',
    border: '#EFECEC',
    border_selected: 'lightgray',
    background: 'white',
    footerBg: '#EFECEC',
    footerBg_selected: '#f7f7f7',
    checkboxSelected: '#252525'
  },
  errorCode: {
    default: "Une erreur est survenue avec Resamania",
    "api.error.sale.contact-invalid-data":"Veuillez essayer avec une autre adresse mail ou contacter le club directement.",
    "api.error.generic.less-than": "Vous n'avez pas l'âge minimum requis pour vous inscrire",
    CAPTCHA_INVALID: "La vérification anti-robot a échoué. Merci de réessayer.",
    PHONE_INVALID: "Ce numéro de téléphone n'est pas valide.",
    PHONE_COUNTRY_NOT_ALLOWED: "Les numéros de ce pays ne sont pas acceptés. Merci d'indiquer un autre mobile.",
    EMAIL_ALREADY_USED: "L’adresse e-mail fournie est déjà enregistrée dans notre système. Veuillez utiliser une autre adresse e-mail ou contacter le club.",

    MISSING_STOCK: "Il n'y a plus assez de stock disponible",
    PROMO_CODE_INACTIVE: "Ce code promo n'est plus valable",
    PROMO_CODE_NOT_FOUND: "Ce code promo est introuvable",
    CODE_NOT_FOUND: "Ce code n'existe pas",
    CODE_DELETED: "Ce code n'existe plus",
    CODE_INACTIVE: "Ce code n'est plus valable",
    CODE_USED: "Ce code a déjà été utilisé",
  },
  clubTransfer: {
    enabled: false,
    errorCode: "api.error.contact.email-already-used",
    requestTitle: "Heureux de vous revoir !",
    requestMessage: "Vous avez déjà utilisé cette adresse mail pour échanger avec un de nos clubs.",
    requestMessageWithEmail: "Pour continuer votre inscription avec ##{email}## à ##{clubName}##",
    requestInstructionsWithPhone: "il vous suffit de saisir le code que vous allez recevoir par SMS au ##{phone}##",
    requestInstructions: "il vous suffit de cliquer sur le bouton ci-dessous pour recevoir un code de vérification par SMS.",
    requestButtonLabel: "Recevoir le code SMS",
    requestCancelLabel: "Changer d'adresse e-mail",
    loadingLabel: "Envoi du code en cours...",
    codeTitle: "Validez le transfert",
    codeMessage: "Un SMS vous a été adressé. Saisissez le code ici pour confirmer le transfert vers le nouveau club.",
    codePlaceholder: "Code reçu par SMS",
    codeButtonLabel: "Confirmer",
    confirmLoadingLabel: "Vérification en cours...",
    codeResendButtonLabel: "Renvoyer le SMS",
    errorMessage: "Une erreur est survenue. Veuillez vérifier votre adresse e-mail ou contacter le club.",
    confirmTitle: "Transfert confirmé",
    confirmMessage: "C'est tout bon ! Vous pouvez maintenant poursuivre votre inscription.",
    confirmButtonLabel: "Continuer",
  },
  sign : {
    title: 'Signature du contrat',
    placeholder: "Code reçu par SMS",
    explain: "Entrer ici le code reçu par SMS pour signer le contrat",
    resendCodeLabel: "Renvoyer le code",
    badCodeLabel: "Code incorrect",
    signLabel: "Valider la signature",
  },
  payment: {
    loadingLabel: "Vérification en cours",
    informationLabel: "Informations de paiement",
    resumeLabel: "Total à payer par CB: ",
    payLabel: "Payer ",
    errorLabel: "Nous avons un soucis avec votre paiment.",
    errorTitle: "Une erreur est survenue",
    paylineTitle: "Payer avec Payline",
    paylineLabel: "Votre inscription est effective, il ne vous reste plus qu'à régler par carte la somme de ",
  },
  loadingDefault: "Chargement en cours",
  loadingSmsCodeCheck: 'Vérification du code',
  loadingSmsCodeSend: 'Envoi du SMS',
  loadingTextUserCreation: "Création de votre compte",
  loadingTextCartCreation: "Création de votre panier",
  loadingTextAddressCheck: "Vérification de votre adresse",
  loadingTextOffersLoad: "Chargement des offres",
  useClubImgInClubList: true, // afficher l'image du club dans la page de sélection de club
  plans: {
    displayCompanyAndClubName: false,
    formatName: (name) => name,
    buttonTitle: null, // Permet d'afficher un bouton directement dans la card de chaque plan, au lieu du bouton "suivant" en dessous des cards
    withBanner: false,
    countdown: { // compte à rebours affiché sous la bannière quand l'offre a une date d'expiration
      title: "Ton offre exceptionnelle se termine dans",
      labels: { days: "Jours", hours: "Heures", minutes: "Minutes", seconds: "Secondes" },
      endedText: "Cette offre est terminée 😔",
    },
    beforeUser: true,
    noPlanFoundTitle: "Aucune formule",
    noPlanFoundTexts : [
      "Nous n'avons trouvé aucune formule pour ce club,",
      "veuillez réessayer plus tard ou changer de club via l'étape 1"
    ],
    splitCounterAbo: false,
    useImg : 'withText',
    imageBaseURL: 'https://api.resamania.com',
    title: "Je choisis ma formule",
    incitation: "Sélectionnez une formule pour continuer",
    feesLabel : "Frais d'inscription",
    feesLabelComplement: "",
    customConfig: {
      isIncluded: () => false,
      subClass: null // custom class for sub2 and sub3 for clubs that match isIncluded
    },
    nofeesLabel: "Aucun frais d'inscription",
    topOfferTitle: false,
    autoSubmit: false,
    nextLabel: "Suivant",
  },
  productsLoader : {
    errorTitle: "Une erreur est survenue avec Resamania2",
    errorText: 'Veuillez réessayer plus tard ou avec un autre club',
  },
  options: false,
  regulars : false,
  recap: {
    title: "Ma sélection",
    myOffer: "Ma formule",
    myOption: "Mes options",
    myCounter: "Mes options et équipements",
    nextLabel: "Je confirme",
    payByCardLabel: "Total à payer par carte",
    payBySepaLabel : "Total prélevé directement",
  },
  sepa : {
    title: "RIB - Paiement Mensuel",
    validateLabel : "J’accepte par la présente les prélèvements automatiques SEPA",
    explain: "Veuillez mettre votre RIB ci-dessous pour valider votre abonnement et signer votre mandat de prélèvement SEPA",
    ownerLabel: "Titulaire du compte",
    ibanLabel: "IBAN",
    bicLabel: "BIC",
    bankLabel: "Nom de la banque",
  },
  contract: {
    title: "Votre contrat",
    signLabel: "Signer le contrat",
  },
  confirmation: {
    welcomeLabel: "Bienvenue chez",
    text: "Votre adhésion a bien été prise en compte, vous recevrez un e-mail de confirmation sous peu.",
    backLabel: "Retour au site."
  },
  steps: {
    useSinglePageForm: false,
    display: {
      showShortNames: true,
    },
    clubSelect: {
      noAddress: true,
      showMap: "Masquer la carte",
      hideMap: "Voir la carte",
      title: 'Je choisis mon club',
      nextLabel: "Suivant",
      withMap: false,
      searchable:false,
      sameLine: false,
      autoSelect: true,
    },
    userForm: {
      nextLabel: "Suivant",
      genderLabel: 'Civilité',
      gender_F: "Mme",
      gender_M: "M.",
      firstnameLabel: 'Prénom',
      lastnameLabel: "Nom",
      emailLabel: 'Adresse e-mail',
      phoneLabel: "Nº de téléphone portable",
      phoneExplain: "Utilisé pour la signature du contrat et du mandat SEPA",
      birthdateLabel: "Date de naissance",
      addressLabel: "Adresse",
      backLabel: "Retour",
      noClub: true,
      noGender: false,
      noAddress: false,
      noBirthdate: false,
      title: "MES COORDONNÉES",
      internalOptins: { // just for form validation
        step: null, // user | summary
        groups: [
          {
            id: "",
            label: "",
            type: "", // xor = exactement une doit être cochée
            required: false,
            options: [
              {
                key: "",
                label: ""
              }
            ]
          }
        ]
      },
      optins: { // optins sent to resamania
        acceptLegal: {
          text: null,
          moreLabel: null,
          href: null,
          step: 1,
          required: false,
          openInModal: false // ouvrir les cgv dans une modale plutôt que dans une nouvelle page (pour éviter de bloquer les bornes par exemple)
        },
        acceptNewsletter: {
          text: null,
          subtext: null,
          step: 1,
        },
        acceptAdvertising: {
          text: null,
          subtext: null,
          step: 1,
        },
        acceptPartner: {
          text: null,
          subtext: null,
          step: 1,
        }
      }
    },
  },
  stepsLabels: {
    club: "Votre club",
    contact: "Vos coordonnées",
    plans: "Formules d'abonnement & options",
    contract: "Contrat",
    payment: "Informations de paiement",
    photo: "Votre photo",
  },
  stepsShortLabels: {
    club: "Club",
    contact: "Contact",
    plans: "Formules",
    contract: "Contrat",
    payment: "Paiement",
    photo: "Photo",
  },
  rootProperties: {
    'primary': '#252525',
    'primary--dark': 'darken(#252525, 15)',
    'placeholder': '#999999',
    'border': '#3d3d3d',
  },
  htmlStyle: '',
  htmlCustomCSS: '',
  theme: {
    primary: '#252525',
    stepsDisplay: {
      color: {
        main: '#252525',
        bgFilled: '#252525',
        textFilled: 'white',
        subText: '#252525',
      }
    },
    loader : {
      border: 'black',
      border2: '#252525'
    },
    fontFamily: "Montserrat, sans-serif",
    buttonPrimary: {
      color: '#252525',
      text: '#fff',
    },
    buttonOther: {
      color: 'black',
      text: '#fff',
    },
    buttonSecondary: {
      color: "black",
      text: '#fff'
    },
    stepHeader: {
      textTransform: 'uppercase',
    }
  }
};

export default configDefault;
